module.exports = __webpack_public_path__ + "static/builders-f176573e027ef1cfea049070d3275c01.png";